/* Common Imports */

import React from "react";

/* Component Imports */

import Layout from "../components/layout-components/Layout";
// import SectionOne from "../components/page-sections/about-us/SectionOne";
import SectionImage from "../components/page-sections/about-us/SectionImage";
import SectionThree from "../components/page-sections/about-us/SectionThree";
import SectionTwo from "../components/page-sections/about-us/SectionTwo";
import ContactUs from "../components/page-sections/index/ContactUs";

/* Session Imports */

import { withIronSessionSsr } from "iron-session/next";
import { sessionOptions } from "../lib/session";

const AboutUs = ({ user }) => {
  return (
    <React.Fragment>
      <Layout
        noContainer
        user={user}
        title="About Sentient Developers | Sustainable & Luxury Homes In Bengaluru"
        description="Learn about Sentient Developers, pioneers in crafting sustainable, eco-friendly, and luxurious homes in Bengaluru. Explore our vision, mission, and values."
      >
        {/* <SectionOne /> */}
        <SectionImage />
        {/* <SectionOneNew /> */}
        <SectionTwo />
        <SectionThree />
        {/* <SectionFour /> */}
        <ContactUs source="About Us Page" />
      </Layout>
    </React.Fragment>
  );
};

export default AboutUs;

// eslint-disable-next-line space-before-function-paren
export const getServerSideProps = withIronSessionSsr(async function ({ req, res }) {
  /* Getting user session cookie */
  const user = await req.session.user;

  /* User Authorization */
  if (user == undefined) {
    return {
      props: {
        user: { isLoggedIn: false },
      },
    };
  } else {
    /* Pass data to the page via props */
    return {
      props: { user: req.session.user },
    };
  }
}, sessionOptions);
